import { Injectable, signal, effect } from '@angular/core';
import { Schule } from './schule-overview/schule';

@Injectable({ providedIn: 'root' })
export class SchuleService {
    public schule = signal<Schule | null>(this.readFromStorage());

    private readFromStorage(): Schule | null {
        try {
            const raw = localStorage.getItem('currentSchule');
            return raw ? (JSON.parse(raw) as Schule) : null;
        } catch {
            localStorage.removeItem('currentSchule');
            return null;
        }
    }

    constructor() {
        effect(() => {
            const current = this.schule();
            if (current) {
                localStorage.setItem('currentSchule', JSON.stringify(current));
            } else {
                localStorage.removeItem('currentSchule');
            }
        });
    }
}
